// Procedural Taj Mahal quartzite for the 3D edge previews: warm ivory ground with soft
// cloudy mottling, long honey-gold veins, a few thin grey ones and fine crystalline grain.
const rng = (seed) => () => {
  seed = (seed * 1664525 + 1013904223) % 4294967296;
  return seed / 4294967296;
};

const veinPath = (r, size, angle) => {
  const n = 7;
  const len = size * 1.7;
  const cx = r() * size;
  const cy = r() * size;
  const dx = Math.cos(angle);
  const dy = Math.sin(angle);
  const pts = [];
  for (let i = 0; i <= n; i++) {
    const t = i / n - 0.5;
    const wob = (r() - 0.5) * size * 0.14;
    pts.push([cx + dx * len * t - dy * wob, cy + dy * len * t + dx * wob]);
  }
  return pts;
};

const stroke = (ctx, pts, { color, width, alpha, blur }) => {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.shadowColor = color;
  ctx.shadowBlur = blur;
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length - 1; i++) {
    const [x1, y1] = pts[i];
    const [x2, y2] = pts[i + 1];
    ctx.quadraticCurveTo(x1, y1, (x1 + x2) / 2, (y1 + y2) / 2);
  }
  const [xe, ye] = pts[pts.length - 1];
  ctx.lineTo(xe, ye);
  ctx.stroke();
  ctx.restore();
};

export const tajMahalCanvas = (size = 1024, seed = 11) => {
  const c = document.createElement("canvas");
  c.width = size;
  c.height = size;
  const ctx = c.getContext("2d");
  const r = rng(seed);

  ctx.fillStyle = "#e8e0cf";
  ctx.fillRect(0, 0, size, size);

  const tones = ["#f3eee3", "#e0d6c2", "#d6cab3", "#eee5d4", "#dbd2c1", "#c9bda6"];
  for (let i = 0; i < 300; i++) {
    const x = r() * size;
    const y = r() * size;
    const rad = size * (0.05 + r() * 0.2);
    const g = ctx.createRadialGradient(x, y, 0, x, y, rad);
    g.addColorStop(0, tones[Math.floor(r() * tones.length)]);
    g.addColorStop(1, "rgba(232,224,207,0)");
    ctx.globalAlpha = 0.18 + r() * 0.22;
    ctx.fillStyle = g;
    ctx.fillRect(x - rad, y - rad, rad * 2, rad * 2);
  }
  ctx.globalAlpha = 1;

  const base = -0.62;
  for (let i = 0; i < 6; i++) {
    const pts = veinPath(r, size, base + (r() - 0.5) * 0.35);
    stroke(ctx, pts, { color: "#c5a06c", width: 16 + r() * 22, alpha: 0.14, blur: 34 });
    stroke(ctx, pts, { color: "#b08a55", width: 2.5 + r() * 3, alpha: 0.32, blur: 5 });
  }
  for (let i = 0; i < 4; i++) {
    const pts = veinPath(r, size, base + (r() - 0.5) * 0.5);
    stroke(ctx, pts, { color: "#9d948a", width: 1.2 + r() * 1.6, alpha: 0.26, blur: 3 });
  }

  for (let i = 0; i < 12000; i++) {
    ctx.fillStyle = r() > 0.55 ? "rgba(110,95,75,0.09)" : "rgba(255,255,255,0.16)";
    const s = 0.8 + r() * 1.6;
    ctx.fillRect(r() * size, r() * size, s, s);
  }
  return c;
};
